var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAttachmentSample = function SvgAttachmentSample(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 38,
    viewBox: "0 0 28 38",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M28 8v25.244C28 35.871 26.02 38 23.579 38H4.42C1.98 38 0 35.876 0 33.245V4.755C0 2.13 1.981 0 4.417 0h15.486L28 8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D9EAFF",
    d: "M20 0l8 8h-4.998A2.999 2.999 0 0 1 20 4.998V0z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAttachmentSample);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/attachment-sample.8dc7f5752a98442ae9c4aa4ec8ded1ab.svg";